import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type Notifier from "cc-frontend/services/notifier"
import type { EmberNotification } from "cc-frontend/services/notifier"

interface EmberNotifierSignature {
  Args: {
    position?: string
    notificationClass?: string
    iconComponent?: string
    contentComponent?: string
    closeComponent?: string
  }
  Blocks: {
    default: [notification: EmberNotification, close: () => void]
  }
  Element: HTMLDivElement
}

export default class EmberNotifierComponent extends Component<EmberNotifierSignature> {
  @service declare notifier: Notifier

  get notifications() {
    return this.notifier.notifications
  }

  get position() {
    return this.args.position ?? "is-top-right"
  }

  get notificationClass() {
    return this.args.notificationClass ?? "ember-notifier-notification"
  }

  willDestroy() {
    super.willDestroy()
    this.notifier.empty()
  }

  @action
  remove(notification: EmberNotification) {
    this.notifier.remove(notification)
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    EmberNotifier: typeof EmberNotifierComponent
  }
}
